import { useEffect, useState } from 'react'

export function useIsMobile() {
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 768px)')
        setIsMobile(mediaQuery.matches)

        const handleResize = (e: MediaQueryListEvent) => {
            setIsMobile(e.matches)
        }

        mediaQuery.addEventListener('change', handleResize)

        return () => {
            mediaQuery.removeEventListener('change', handleResize)
        }
    }, [])

    return isMobile
} 